import { useDropzone } from "react-dropzone";
import { Box, Button, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export const TeamGearPhotoUploader = ({ file, setFile }) => {

    const onFileAccepted = (selected) => {
        setFile(selected);
    };

    const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
        accept: {
            "image/jpeg": [".jpeg"],
        },
        multiple: false,
        noClick: true,
        onDrop: (acceptedFiles) => {
            if (acceptedFiles.length === 0) return;
            const selected = acceptedFiles[0];
            onFileAccepted(selected);
        }
    });

    return (
        <Box
            {...getRootProps()}
            sx={{
                border: "2px dashed #888",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
                backgroundColor: isDragActive ? "#f0f0f0" : "background.paper",
                transition: "background-color 0.2s ease",
                cursor: "pointer",
            }}
        >
            <input {...getInputProps()} />
            <CloudUploadIcon sx={{ fontSize: 40, mb: 1 }} />
            <Typography>
                {isDragActive ? "Drop the file here..." : "Drag & Drop a JPEG file here"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                or
            </Typography>
            <Button
                variant="outlined"
                sx={{ mt: 1 }}
                onClick={open}
            >
                Select File
            </Button>
            {file && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                    Selected: {file.name}
                </Typography>
            )}
        </Box>
    );
}